import { Deserializable } from '../protocols/deserializable';
import { TransactionEntryCodeType } from './transaction-entry-code-type';

export class MemberAccountContributionBalance implements Deserializable {
  public entryCodeId!: number;
  public totalBalance!: number;
  public entryCode!: TransactionEntryCodeType;

  public onDeserialize(): void {
    if (this.entryCode) {
      this.entryCode = window?.injector?.Deserialize.instanceOf(TransactionEntryCodeType, this.entryCode);
    }
  }
}
